(() => {
  const nativeFetch = window.fetch.bind(window);

  function normalizeProductJsonUrl(rawUrl) {
    const url = new URL(rawUrl, window.location.origin);
    url.search = '';
    url.hash = '';
    url.pathname = `${url.pathname.replace(/\.js$/i, '').replace(/\/$/, '')}.js`;
    return url;
  }

  function findMatchingRecommendationButton(requestUrl) {
    const buttons = document.querySelectorAll(
      'langley-cart-enhancements [data-langley-choose-options][data-product-json-url]'
    );

    return [...buttons].find((button) => {
      try {
        return normalizeProductJsonUrl(button.dataset.productJsonUrl).pathname === requestUrl.pathname;
      } catch {
        return false;
      }
    });
  }

  async function fetchRecommendedProduct(button) {
    const recommendations = button.closest('product-recommendations');
    if (!(recommendations instanceof HTMLElement)) return null;

    const sourceProductId = recommendations.dataset.productId;
    const targetProductId = button.dataset.productId;
    const rawUrl = recommendations.dataset.url || '/recommendations/products?limit=8';

    if (!sourceProductId || !targetProductId) return null;

    const url = new URL(rawUrl, window.location.origin);
    url.pathname = `${url.pathname.replace(/\.json$/i, '').replace(/\/$/, '')}.json`;
    url.searchParams.set('product_id', sourceProductId);
    url.searchParams.set('intent', recommendations.dataset.intent || 'related');

    const response = await nativeFetch(url.toString(), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });

    if (!response.ok) return null;

    const data = await response.json();
    const products = Array.isArray(data?.products) ? data.products : [];

    return products.find((product) => String(product.id) === String(targetProductId)) || null;
  }

  window.fetch = async (input, init) => {
    const response = await nativeFetch(input, init);

    try {
      const rawRequestUrl =
        typeof input === 'string' || input instanceof URL ? String(input) : input?.url;

      if (!rawRequestUrl) return response;

      const requestUrl = new URL(rawRequestUrl, window.location.origin);
      const isSameOrigin = requestUrl.origin === window.location.origin;
      const isProductJson = /\/products\/[^/]+\.js$/i.test(requestUrl.pathname);
      const isJsonResponse = (response.headers.get('content-type') || '').includes('json');

      if (!isSameOrigin || !isProductJson || (response.ok && isJsonResponse)) {
        return response;
      }

      const button = findMatchingRecommendationButton(requestUrl);
      if (!(button instanceof HTMLButtonElement)) return response;

      const product = await fetchRecommendedProduct(button);
      if (!product) return response;

      return new Response(JSON.stringify(product), {
        status: 200,
        headers: { 'Content-Type': 'application/json; charset=utf-8' },
      });
    } catch (error) {
      console.warn('Langley cart product fallback failed:', error);
      return response;
    }
  };
})();
